module.exports = " <div class=component-view> <loader v-show=loading></loader> <router-view class=view></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/View.vue
// module id = 730
// module chunks = 2